import { MatDateFormats } from '@angular/material/core';

export const DATE_FORMAT = 'YYYY/MM/DD'; // 日期格式
export const API_DATE_FORMAT = 'YYYYMMDD'; // API參數日期格式

// 將datepicker的日期格式設置為YYYY/MM/DD
export const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: DATE_FORMAT,
  },
  display: {
    dateInput: DATE_FORMAT,
    monthYearLabel: 'YYYY MMM',
    dateA11yLabel: DATE_FORMAT,
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
